import { render, staticRenderFns } from "./AccountSponsorship.vue?vue&type=template&id=78e40967&"
import script from "./AccountSponsorship.vue?vue&type=script&lang=js&"
export * from "./AccountSponsorship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports